import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'
import swal from 'sweetalert2'
// import getSearchParam from '@newswebsiteapp/shared/lib/getSearchParam'

controllerLoadedObservableFactory('publication_list_page').subscribe(() => {
  // Check if the query parameter 'nmi_successful_transid' is present in the current location
  // const transactionId = getSearchParam('nmi_successful_transid', window.location.href)
  // const queryString = window.location.search
  // const urlParams = new URLSearchParams(queryString)
  // console.log(urlParams)
  // const transactionIdHas = urlParams.has('nmi_successful_transid')
  // const transactionId = urlParams.get('nmi_successful_transid')

  const transactionId = window.location.href.includes('nmi_successful_trans')

  if (transactionId) {
    // Do something if 'nmi_successful_transid' is present
    console.log('Transaction ID:', transactionId)
    // Perform additional actions or redirect if needed

    swal.fire({
      title: 'Donation was successful',
      text: 'Your donation has been successfully submitted. Thank you for your support.',
      icon: 'success',
      confirmButtonText: 'Close',
    })
  } else {
    // Do something else if 'nmi_successful_transid' is not present
    console.log('Transaction ID not found')
  }
})
